const fetchInitialState = {
  code: '',
  mappings: null,
  fetching: false,
};

const fetch = (state = fetchInitialState, action) => {
  switch (action.type) {
    case 'FETCH_MAPPING':
      return {
        ...state,
        fetching: true,
      };

    case 'FETCH_MAPPING_SUCCESS':
      return {
        ...state,
        fetching: false,
        code: action.code,
        mappings: action.code,
      };

    case 'FETCH_MAPPING_FAILURE':
      return {
        ...state,
        fetching: false,
      };

    case 'UPDATE_MAPPING_SUCCESS':
      return {
        ...state,
        code: action.code,
        mappings: action.code,
      };

    default:
      return state;
  }
};

export default fetch;

export const isFetching = (state) => state.fetching;

export const getCode = (state) => state.code;

export const getMappings = (state) => state.mappings;
